import React from 'react'
import BackIcon from 'assets/images/rectangle/right-green.svg'
import { useNavigate } from 'react-router-dom'
export default function Header({ title }: { title: string }) {
    const navigate = useNavigate()
    return (
        <div className=" w-full bg-transparent flex items-center justify-between px-4 h-14">
            <button
                type="button"
                onClick={() => navigate(-1)}
                aria-label="بازگشت"
                className=" -m-2.5 p-2.5 active:scale-90"
            >
                <img src={BackIcon} alt="" className=" w-6 h-6" />
            </button>
            <p className=" text-green-1 text-lg font-bold">{title}</p>
            <span className="w-6" />
        </div>
    )
}
